import { HomeClockOutlineIcon } from './HomeClockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 9ADA7472-66EE-4F9A-8494-C4292C29207C
 * name home-clock-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-clock-outline.svg
 * tags
 * - Home Automation 
 * - Date / Time 
 */
export const HouseScheduleOutlineIcon = HomeClockOutlineIcon;
export default HouseScheduleOutlineIcon